<template>
  <div class="coures-container">
    <div class="courseDetails" onclick="_hmt.push(['_trackEvent', 'website', 'click', '点击'])">
      <meta name="keywords" :content="courseName+'+'+introduce+'+'+'以诺教育;诺亚财富'">
      <meta
        name="description"
        content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
      >
      <title>{{name}}-以诺教育</title>
      <headTop></headTop>
      <Breadcrumb class="crumbs" separator="<span class='demo-breadcrumb-separator'>></span>">
        <BreadcrumbItem href="/">首页</BreadcrumbItem>
        <BreadcrumbItem href="/courseList">全部课程</BreadcrumbItem>
        <BreadcrumbItem href="/courseList">{{zhClasses}}</BreadcrumbItem>
        <BreadcrumbItem style="color:#909090;font-weight: normal;">课程详情</BreadcrumbItem>
      </Breadcrumb>
      <!--<div class='crumbs'>首页<span class='next'>></span>全部课程<span class='next'>></span>投资管理<span class='next'>></span><i  class='detailses'>课程详情</i></div>-->

      <div class="screen">
        <div class="banner">
          <Carousel
            :autoplay="zzz"
            :autoplaySpeed="5000"
            v-model="value2"
            arrow="hover"
            dots="none"
          >
            <CarouselItem v-for="(item,index) in listB" :key="item.id">
              <div class="splitScreen">
                <video
                  id="v1"
                  v-if="shipin?true:false"
                  :src="shipin"
                  controls="controls"
                  style="position: absolute;"
                  height="100%"
                  width="500"
                  v-show="index==0?true:false"
                  onerror="alert('网速不好')"
                  preload
                >
                  <div class="videoplay">该浏览器不支持视频播放 ^_^</div>
                </video>
                <img :src="item.url">
              </div>
            </CarouselItem>
          </Carousel>
        </div>
        <div class="content1" v-for="infoT in foundation" :key="infoT.name">
          <p class="title">{{infoT.name}}</p>
          <div class="information">
            <div class="introduce" v-for="v in introduce" :key="v">{{v}}</div>
          </div>
          <div class="informationTow">
            <li class="membership">
              {{infoT.price_type}}
              <img
                src="../../assets/heika.png"
                class="heika"
                @mouseenter="enter"
                @mouseleave="leave"
                v-show="huang"
              >
              <b class="membershipValue">{{infoT.price}}</b>&nbsp;
              <span>元/人</span>
            </li>
            <li class="marketvalue" v-show="member">{{infoT.market_price}}元/人</li>
            <!-- <div class="places">
            	<p class="peopleNumber">{{infoT.surplus}}</p>
            	<p class="onlyPlaces">仅剩名额</p>
            </div>-->
            <div class="Dhide">
              <div class="triangle"></div>
              <div class="blackCard">黑卡用户不能同时享受其他优惠，如果对优惠有疑问，请联系客服处理</div>
            </div>
          </div>
          <div class="clear"></div>
          <div class="coupon" v-if="couponzzz" v-show="coupones.length==0?false:true">
            <p class="couponWord">优惠</p>
            <ul class="prize">
              <li class="prizeChild" v-for="(hui,index) in coupones" :key="index">
                <span class="fullCut">{{hui.classify}}</span>
                <a @click="couponss(hui)" :disabled="receiveOne">{{hui.name}}</a>
                <i v-show="index==1?true:false">
                  <Icon type="arrow-up-b" class="dropDown"></Icon>
                </i>
                <!-----------------------------------------弹出层---------------------------------------------->
                <div class="popup" v-show="popup">
                  <div class="receive" v-for="quan in couponess" :key="quan.name">
                    <p @click="closes">
                      <Icon type="close" class="abrog"></Icon>
                    </p>
                    <p class="receiveWord">{{receive}}</p>
                    <div class="Vouchers">
                      <div class="VouchersLeft">
                        <div class="amountNumber">
                          <span>{{quan.price}}</span> 元
                          <i>{{quan.name}}</i>
                        </div>
                        <p class="moneyTime">{{quan.range}}</p>
                        <p class="moneyTime">有效期：{{quan.time_out}}</p>
                      </div>
                      <div class="VouchersRight">
                        已
                        <br>领
                        <br>取
                      </div>
                    </div>
                    <div class="Determine" @click="closes">确认，继续报名></div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="clear"></div>
          </div>
          <div class="place">
            地点
            <span>{{infoT.address}}</span>
          </div>
          <div class="couseTime">
            课程时间
            <span>{{infoT.classes_begin}} 至 {{infoT.classes_end}}</span>
          </div>
          <!-- <div @click="signUp" id="signUp"><router-link :to="{name:'order',params:{id:idd}}" :class="{'signUp':isA,'signUp1':isB}" :disabled="infoT.register_state=='未开始'?click:click1" >{{baoming}}</router-link></div> -->
          <div @click="subscribe()" id="signUp">
            <div class="signUp">立即咨询</div>
          </div>
          <div class="signupEnd" v-show="jie">报名截止{{countdown}}天</div>
        </div>
        <div class="clear"></div>
      </div>

      <div class="synopsis">
        <div id="one" class="tableB active">课程简介</div>
        <div id="two" class="tableB">详情介绍</div>
        <div id="three" class="tableB">报名须知</div>
        <div class="clear"></div>
      </div>
      <div class="details" id="introduct">
        <p class="subject">课程简介</p>
        <p class="jianjie">{{title}}</p>
      </div>
      <div id="arrange">
        <div class="scheduleTt">
          <p class="subject">详情介绍</p>
          <img v-for="ke in course" :src="ke.url" :key="ke.url" class="scheduleP">
        </div>
      </div>
      <div class="details" id="refund">
        <p class="subject">报名须知</p>
        <div v-html="richtext" class="richtext"></div>
      </div>
    </div>
    <Bottom></Bottom>
    <div class="right-buttons">
      <div
        class="right-button"
        :class="buttonIndex == 1? 'active' : ''"
        @click="closeSubOnline();openConsult();"
      >
        <span class="iconfont icon-nav_pc-icon_zaixianyuyue"></span>
        <p>在线咨询</p>
      </div>
      <div
        class="right-button"
        :class="buttonIndex == 2? 'active' : ''"
        @click="closeSubOnline();buttonIndex = 2;"
        @mouseleave.prevent="buttonIndex == 2? buttonIndex = null: ''"
      >
        <span class="iconfont icon-nav_pc-icon_zixundianhua"></span>
        <p>电话咨询</p>
      </div>
    </div>

    <div class="serverPhone" v-show="buttonIndex == 2">
      <p class="kefuphone">400-820-0025</p>
      <p class="zhuanxian">拨通转6号线进入专线</p>
    </div>
    <div
      class="iframe-container"
      v-if="buttonIndex == 1"
      @click="buttonIndex = null;iframeLoaded = false"
    >
      <Spin fix v-show="!iframeLoaded">
        <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
        <div>加载中</div>
      </Spin>
      <iframe
        id="consult-ol"
        frameborder="0"
        width="600px"
        height="600px"
        :src="iframeSrc"
        @load="iframeLoad()"
      ></iframe>
    </div>

    <div
      class="sub-online-container"
      v-if="!subOnlineClose"
      @click.self="buttonIndex = null;closeSubOnline()"
    >
      <div class="sub-online">
        <div class="title">在线预约免费领取课程资料</div>
        <Form :model="subscribeForm">
          <FormItem>
            <Input :disabled="true" size="large" v-model="subscribeForm.className"></Input>
          </FormItem>
          <FormItem prop="name">
            <Input
              v-model="subscribeForm.name"
              placeholder="请输入姓名"
              :disabled="!!userName"
              size="large"
            ></Input>
          </FormItem>
          <FormItem prop="phone">
            <Input
              v-model="subscribeForm.phone"
              placeholder="手机号"
              :disabled="!!userPhone"
              size="large"
              :maxlength="11"
              @on-change="FormPhoneChange"
            ></Input>
          </FormItem>
          <FormItem class="tuCode" v-if="needCaptcha">
            <Row type="flex" justify="space-between">
              <Col span="13">
                <Input v-model="subscribeForm.captcha" placeholder="请输入图形验证码" size="large"></Input>
              </Col>
              <Col span="9">
                <img :src="captcha" @click="captchaGet()" alt>
              </Col>
            </Row>
          </FormItem>
          <FormItem class="code" v-if="!token">
            <Row type="flex" justify="space-between">
              <Col span="13">
                <Input v-model="subscribeForm.code" placeholder="请输入验证码" size="large"></Input>
              </Col>
              <Col span="9">
                <Button
                  :class="{'disable': fasong || !subPhone}"
                  :disabled="fasong || !subPhone"
                  @click="codeNumber()"
                >
                  获取验证码
                  <span v-if="fasong">{{time}}</span>
                </Button>
              </Col>
            </Row>
          </FormItem>

          <p class="errormessage sser" v-if="userCode">{{errormess}}</p>
          <FormItem class="submit">
            <Button @click="submit()">立即提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "../headTop/headTop";
import Bottom from "../Bottom/Bottom";
import http from "../../http.js";
export default {
  name: "CourseDetails",
  components: { headTop, Bottom },
  data() {
    return {
      value2: 0,
      zhClasses: "",
      title: "",
      name: "",
      introduce: [],
      listB: [],
      foundation: [],
      course: [],
      coupones: [],
      couponess: [],
      idd: this.$route.params.id,
      token: localStorage.getItem("token"),
      click: true,
      isA: "",
      isB: "",
      baoming: "",
      jie: true,
      courseName: "",
      drop: false,
      dropDown: false,
      popup: false,
      receive: "",
      countdown: "",
      receiveOne: false,
      userCode: false,
      errormess: "",
      disable: false,
      shipin: "",
      zzz: true,
      richtext: "",
      time: 60,
      fasong: false,
      qrcodeUrl: "",
      buttonIndex: null,
      subOnlineClose: true,
      subscribeForm: {},
      userName: "",
      userPhone: "",
      iframeLoaded: false,
      subPhone: false,
      needCaptcha: false,
      captcha: "",
      fgroup_num: '',
      user_id: '',
      iframeSrc: ''
    };
  },
  methods: {
    signUp() {
      if (this.token == null) {
        //					$(".backdrop").css({"display":"block"})
      } else {
        this.$router.push({ name: "order", params: { id: this.idd } });
      }
    },
    couponss(hui) {
      var that = this;
      if (that.token == null) {
        $(".backdrop").css({ display: "block" });
      } else {
        that.popup = true;
        that.receiveOne = true;
      }
      that
        .$ajax({
          method: "post",
          url: "/api/couponReceive",
          data: { source: 4, coupon_id: hui.id }
        })
        .then(function(data) {
          if (data.data.error) {
            that.receive = data.data.error.message;
          } else {
            that.receive = data.data.result.msg;
          }
          if (data.data) {
            that.receiveOne = false;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      that
        .$ajax({
          method: "post",
          url: "/api/couponGet",
          data: { cid: that.idd }
        })
        .then(function(data) {
          for (let i = 0; i < data.data.result.length; i++) {
            if (data.data.result[i].id == hui.id) {
              that.couponess = [data.data.result[i]];
            }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    closes() {
      this.popup = false;
    },
    enter() {
      $(".Dhide").css({ display: "block" });
    },
    leave() {
      $(".Dhide").css({ display: "none" });
    },
    closeSubOnline() {
      this.subOnlineClose = true;
      this.chooseClass = true;
      this.subscribeForm = {};
      this.errormess = "";
      this.userCode = false;
      this.buttonIndex = null;
    },
    codeNumber() {
      if (this.fasong) return;
      var that = this;
      that.fasong = true;
      that
        .$ajax({
          method: "post",
          url: "/api/auth/sendPhoneCode",
          data: {
            phone: that.subscribeForm.phone,
            need_img_code: 1,
            img_code: that.subscribeForm.captcha
          }
        })
        .then(function(data) {
          if (data.data.error) {
            that.errormess = data.data.error.message;
            that.userCode = true;
            that.fasong = false;
            if (data.data.error.code == 16006) {
              that.needCaptcha = true;
              that.captchaGet();
            }
          } else {
            that.userCode = false;
            that.fasong = true;
            var timera = setInterval(function() {
              that.time--;
              if (that.time == 0) {
                clearInterval(timera);
                that.time = 60;
                that.fasong = false;
              }
            }, 1000);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    submit() {
      this.errormess = "";
      if (!this.subscribeForm.id) {
        this.errormess = "请选择课程";
      }

      if (!this.subscribeForm.name) {
        this.errormess = "请输入正确的姓名";
      }
      // 未登录状态检查姓名与手机号格式
      if (!this.token) {
        if (!/^1[0-9]{10}$/.test(this.subscribeForm.phone)) {
          this.errormess = "请输入正确的手机号";
        }
        if (!this.subscribeForm.code) {
          this.errormess = "请输入验证码";
        }
      }
      if (this.errormess) {
        this.userCode = true;
        return;
      }
      let that = this;
      if (!this.token) {
        that
          .$ajax({
            method: "post",
            url: "/api/reserveAdd",
            data: {
              class_id: that.subscribeForm.id,
              name: that.subscribeForm.name,
              phone: that.subscribeForm.phone,
              source: 4,
              code: that.subscribeForm.code
            }
          })
          .then(function(data) {
            if (data.data.error) {
              that.userCode = true;
              that.errormess = data.data.error.message;
            }
            if (data.data.message == "预约成功") {
              that.closeSubOnline();
              that.$Message.success("预约成功");
            } else {
              that.subOnlineClose = false;
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      } else {
        that
          .$ajax({
            method: "post",
            url: "/api/reserveAdd",
            data: {
              class_id: that.subscribeForm.id,
              source: 4
            }
          })
          .then(function(data) {
            if (data.data.error) {
              that.userCode = true;
              that.errormess = data.data.error.message;
            }
            if (data.data.message == "预约成功") {
              that.closeSubOnline();
              that.$Message.success("预约成功");
            } else {
              that.subOnlineClose = false;
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      }
    },
    subscribe() {
      this.subOnlineClose = false;
      this.subscribeForm.id = this.idd;
      this.subscribeForm.className = this.name;
      this.subscribeForm.name = this.userName;
      this.subscribeForm.phone = this.userPhone;
      this.chooseClass = false;
    },
    iframeLoad() {
      let _this = this
      setTimeout(function() {
        _this.iframeLoaded = true;
      }, 1000)
    },
    FormPhoneChange(e) {
      this.subPhone = /^1[0-9]{10}$/.test(e.target.value);
    },
    // 获取图形验证码
    captchaGet() {
      var that = this;
      this.$ajax({
        method: "post",
        url: "/api/auth/captchaGet",
        params: { phone: this.subscribeForm.phone }
      })
        .then(function(data) {
          that.captcha = data.data.result.imgData;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    openConsult() {
      let custtype = 1;
      let custkey = "";
      let gpno = "";
      let token = localStorage.token;
      if (token) {
        custtype = 2;
        custkey = this.user_id;
        gpno = this.fgroup_num;
      } else {
        custtype = 1;
        custkey = "";
        gpno = "";
      }
      let url = "https://webchat.noahgroup.com/chat/YNXCXLogin.html";
      let randomStr = Math.random()
        .toString(11)
        .substr(2);
      if (custtype == "1") {
        url = `${url}?custtype=${custtype}&custkey=${randomStr}`;
      } else {
        url = `${url}?custtype=${custtype}&custkey=${custkey}${
          gpno ? `&gpno=${gpno}` : ""
        }`;
      }
      this.buttonIndex = 1;
      this.iframeSrc = url
    }
  },
  //		updated(){
  //			$(".richtext").find('p').children().children().css({"fontSize":"14px"})
  //		},
  created() {
    var that = this;
    /*-----------------------------轮播图--------------------------------------*/
    that
      .$ajax({
        method: "post",
        url: "/api/classesDetailBanner",
        params: { id: that.idd }
      })
      .then(function(data) {
        data.data.result.unshift("<img src='' />");
        that.listB = data.data.result;
        that
          .$ajax({
            method: "post",
            url: "/api/classesDetailVideo",
            params: { cid: that.idd }
          })
          .then(function(data) {
            $(".splitScreen img").addClass("dibian");
            that.shipin = data.data.result;
            if (data.data.result == "") {
              that.listB.shift("<img src='' />");
            }
            setTimeout(() => {
              var oV = document.getElementById("v1");
              if (oV) {
                oV.onplay = function() {
                  that.zzz = false;
                };
                oV.onpause = function() {
                  that.zzz = true;
                };
                oV.onended = function() {
                  this.currentTime = 0;
                  this.pause();
                };
              }
            }, 0);
          })
          .catch(function(err) {
            console.log(err);
          });
      })
      .catch(function(err) {
        console.log(err);
      });
    if (this.token) {
      this.$ajax({
        method: "post",
        url: "/api/UserInfo"
      }).then(function(data) {
        localStorage.setItem("name", data.data.real_name);
        localStorage.setItem("phone", data.data.phone);
        that.userName = that.subscribeForm.name = data.data.real_name;
        that.userPhone = that.subscribeForm.phone = data.data.phone;
        that.user_id = data.data.user_id;
        that.fgroup_num = data.data.fgroup_num;
      });
    }
  },
  mounted() {
    $(document).scrollTop(0);
    var that = this;
    $(".tableB").click(function() {
      $(".tableB").removeClass("active");
      $(this).addClass("active");
    });

    /*-------------------------------优惠券-------------------------------------*/
    that
      .$ajax({
        method: "post",
        url: "/api/couponGet",
        data: { cid: that.idd }
      })
      .then(function(data) {
        // that.coupones = data.data.result;
        // if (data.data.result.length >= 2) {
        //   data.data.result.length = 2;
        // }
        /*-----------------------------详情页基础接口--------------------------------------*/
        that
          .$ajax({
            method: "post",
            url: "/api/classesDetailGet",
            params: { id: that.idd }
          })
          .then(function(data) {
            that.foundation = data.data.result;
            that.title = data.data.result[0].t_summary;
            that.introduce = data.data.result[0].table;
            that.name = data.data.result[0].name;
            that.courseName = data.data.result[0].course_name;
            that.qrcodeUrl = data.data.result[0].qrcode_url;
            that.countdown = Math.ceil(
              data.data.result[0].countdown_ing / 86400
            );
            if (data.data.result[0].price_status == 0) {
              that.member = false;
            } else {
              that.member = true;
            }
            if (data.data.result[0].price_status == 2) {
              that.huang = true;
              that.couponzzz = false;
            } else {
              that.huang = false;
              that.couponzzz = true;
            }
            if (data.data.result[0].price_status == 3) {
              that.couponzzz = false;
            }
            if (data.data.result[0].register_state == "未开始") {
              that.isB = true;
              that.jie = false;
              that.baoming =
                Math.ceil(data.data.result[0].countdown / 86400) +
                "天后开始报名";
            } else {
              that.isA = true;
              that.baoming = "立即报名";
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      })
      .catch(function(err) {
        console.log(err);
      });

    /*-----------------------------课程安排--------------------------------------*/
    that
      .$ajax({
        method: "post",
        url: "/api/GetCourseSyllabus",
        params: { id: that.idd, type: 1 }
      })
      .then(function(data) {
        that.course = data.data.result;
      })
      .catch(function(err) {
        console.log(err);
      });
    /*-----------------------------锚点--------------------------------------*/
    var on = $("#introduct").offset().top;
    var tw = $("#arrange").offset().top;
    $("#one").click(function() {
      $(document).scrollTop(on);
    });
    $("#two").click(function() {
      $(document).scrollTop(tw);
    });
    $("#three").click(function() {
      var th = $("#refund").offset().top;
      $(document).scrollTop(th);
    });
    /*-----------------------------置顶--------------------------------------*/
    $(".top1").click(function() {
      $("body,html").animate({ scrollTop: 0 }, 500);
    });
    /*-------------------------------旋转----------------------------------------*/
    $(document).on("click", ".dropDown", function() {
      that
        .$ajax({
          method: "post",
          url: "/api/couponGet",
          data: { cid: that.idd }
        })
        .then(function(data) {
          if (that.drop == false) {
            $(".dropDown").css({
              transform: "rotate(180deg)",
              "-ms-transform": "rotate(180deg)",
              "-moz-transform": "rotate(180deg)"
            });
            that.drop = true;
            that.coupones = data.data.result;
          } else {
            $(".dropDown").css({
              transform: "rotate(360deg)",
              "-ms-transform": "rotate(360deg)",
              "-moz-transform": "rotate(360deg)"
            });
            that.drop = false;
            data.data.result.length = 2;
            that.coupones = data.data.result;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    });
    /*-------------------------------面包屑----------------------------------------*/
    that
      .$ajax({
        method: "post",
        url: "/api/CourseClassNameGet",
        params: { classes_id: that.idd }
      })
      .then(function(data) {
        that.zhClasses = data.data.result.name;
      })
      .catch(function(err) {
        console.log(err);
      });
    /*-----------------------------shua--------------------------------------*/

    sessionStorage.setItem("xin", 1);
    /*-----------------------------富文本--------------------------------------*/

    that
      .$ajax({
        method: "post",
        url: "/api/InstructionsGet",
        data: { cid: that.idd }
      })
      .then(function(data) {
        that.richtext = data.data.result;
      })
      .catch(function(err) {
        console.log(err);
      });
  }
};
</script>

<style>
.courseDetails {
  background: #f4f5f9;
  padding: 0 0 265px 0;
  box-sizing: border-box;
}
.courseDetails .crumbs {
  width: 1160px;
  color: #4f4f4f;
  font-size: 14px;
  margin: 0 auto;
  padding-top: 27px;
}
.courseDetails .next {
  margin: 8px;
}
.courseDetails .detailses {
  font-style: normal;
  color: #909090;
}
.courseDetails .screen {
  width: 1160px;
  min-height: 365px;
  margin: 18px auto 30px;
  background: #ffffff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.08);
  padding: 30px;
  box-sizing: border-box;
}
.courseDetails .banner {
  width: 500px;
  height: 247px;
  float: left;
}
/*-----------------------------------------信息---------------------------------------------------*/
.courseDetails .content1 {
  width: 570px;
  min-height: 247px;
  float: right;
  position: relative;
}
.courseDetails .splitScreen img {
  width: 100%;
  height: 247px;
}
.courseDetails .title {
  font-size: 22px;
  line-height: 24px;
}
.courseDetails .information {
  height: 49px;
  padding: 12px 0 15px;
  box-sizing: border-box;
}
.courseDetails .introduce {
  box-sizing: border-box;
  border: 1px solid #11cc99;
  font-size: 12px;
  float: left;
  color: #11cc99;
  padding: 0px 6px;
  margin-right: 8px;
}
/*-----------------------------------------会员价---------------------------------------------------*/
.courseDetails .informationTow {
  width: 540px;
  height: 64px;
  box-sizing: border-box;
  background: #f3f3f3;
  position: relative;
}
.informationTow li {
  float: left;
  height: 64px;
  line-height: 64px;
}
.membership {
  margin-left: 38px;
  color: #909090;
}
.membership span {
  color: #fe5555;
  font-weight: 600;
}
.membershipValue {
  font-size: 32px;
  font-weight: 300;
  color: #fe5555;
  margin-left: 12px;
}
.marketvalue {
  margin: 4px 0 0 16px;
  text-decoration: line-through;
  color: #909090;
}
.places {
  float: right;
  margin-right: 16px;
}
.peopleNumber {
  margin: 14px 0 0 0px;
  font-size: 20px;
  color: #4f4f4f;
  text-align: center;
}
.onlyPlaces {
  font-size: 12px;
  color: #909090;
}
.heika {
  display: inline-block;
  margin-left: 6px;
}
.Dhide {
  display: none;
}
.triangle {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 12px solid #fff;
  position: absolute;
  top: 44px;
  left: 85px;
}
.blackCard {
  width: 480px;
  line-height: 54px;
  background: #fff;
  color: #4f4f4f;
  position: absolute;
  top: 56px;
  left: 12px;
  text-align: center;
}
/*-----------------------------------------优惠------------------------------------------------------*/
.coupon {
  width: 540px;
  min-height: 30px;
  border-bottom: 1px solid #eeeeee;
  color: #909090;
  margin-top: 6px;
}
.couponWord {
  float: left;
  margin-left: 50px;
}
.prize {
  float: left;
  margin: 0 0 6px 16px;
}
.prizeChild {
  margin-bottom: 4px;
}
.fullCut {
  width: 35px;
  height: 20px;
  background: #fb6361;
  text-align: center;
  color: #fff;
  display: inline-block;
}
.dropDown {
  margin-left: 10px;
  font-size: 18px;
}
/*-----------------------------------------事件/地点---------------------------------------------------*/
.place {
  margin: 10px 0 4px 55px;
  color: #909090;
}
.place span {
  margin-left: 18px;
  color: #4f4f4f;
}
.couseTime {
  margin-left: 26px;
  color: #909090;
}
.couseTime span {
  margin-left: 18px;
  color: #4f4f4f;
}
.signupEnd {
  float: left;
  margin: 22px 0 0 20px;
  color: #909090;
}
.courseDetails .signUp {
  width: 180px;
  line-height: 44px;
  background: #11cc99;
  float: left;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  margin: 12px 0 0 95px;
  cursor: pointer;
}
.courseDetails .signUp1 {
  width: 180px;
  line-height: 44px;
  background: #dddddd;
  float: left;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #909090;
  text-align: center;
  margin: 12px 0 0 95px;
}
.coupon a {
  color: #909090;
  margin-left: 10px;
}
.courseDetails .coupon a:hover {
  color: #fe5555;
  text-decoration: underline;
}

.courseDetails .synopsis {
  width: 1160px;
  margin: 0 auto;
}
.courseDetails #one,
#two,
#three {
  width: 120px;
  line-height: 50px;
  float: left;
  text-align: center;
  margin-right: 100px;
  font-size: 18px;
}
.courseDetails .clear {
  width: 0;
  height: 0;
  clear: both;
}
.courseDetails #one {
  margin-left: 50px;
}
.courseDetails .scheduleTt {
  width: 1160px;
  margin: 0 auto;
  background: #ffffff;
}
.courseDetails .scheduleP {
  margin-left: 50px;
  width: 750px;
}
.courseDetails .active {
  color: #01b784;
  border-bottom: 4px solid #01b784;
}
.courseDetails .details {
  width: 1160px;
  background: #ffffff;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 50px;
}
.courseDetails .subject {
  font-size: 20px;
  color: #01b784;
  font-weight: bold;
  margin-bottom: 25px;
}
.courseDetails #arrange .subject {
  padding: 20px 50px 10px;
}
.courseDetails .con {
  font-size: 14px;
  color: #4f4f4f;
  padding: 30px 0;
}
.courseDetails .cent {
  font-size: 14px;
  color: #4f4f4f;
}
.courseDetails .details ol {
  margin-top: 30px;
  font-size: 14px;
  color: #4f4f4f;
}
.courseDetails .details ol li {
  margin-left: 25px;
}
.courseDetails .tableB {
  cursor: pointer;
}
.courseDetails .Gotop {
  position: fixed;
  right: 30px;
  bottom: 50px;
  z-index: 20;
}
.courseDetails .jianjie {
  font-size: 14px;
}
.courseDetails .gxpBao {
  font-size: 16px;
}
/*--------------------------------------面包屑-----------------------------------*/
.courseDetails .demo-breadcrumb-separator {
  color: #495060;
  padding: 0 5px;
}
.courseDetails .signUp:hover {
  color: #ffffff;
}
.jiezhi {
  position: absolute;
  right: 16px;
  top: 80px;
  font-size: 14px;
  color: #909090;
}
/*--------------------------------弹出层----------------------------------*/
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 100;
}
.receive {
  width: 400px;
  height: 270px;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -200px;
  margin-top: -135px;
}
.receiveWord {
  margin: 30px 0 20px 30px;
  font-size: 18px;
  font-weight: 600;
  color: #4f4f4f;
}
.Vouchers {
  width: 348px;
  height: 125px;
  background: url(../../assets/youhui1.png) no-repeat -16px -6px;
  margin-left: 26px;
}
.Determine {
  text-align: center;
  margin-top: 25px;
  color: #00b983;
}
.Determine:hover {
  cursor: pointer;
}
.abrog {
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 20px;
  color: #90908f;
}
.VouchersLeft {
  width: 290px;
  height: 125px;
  float: left;
  border-right: 1px dotted #29b999;
}
.VouchersRight {
  width: 52px;
  float: left;
  color: #fff;
  font-size: 18px;
  text-align: center;
  margin-top: 30px;
}
.amountNumber {
  margin: 24px 0 12px 24px;
  color: #fff;
}
.amountNumber span {
  font-size: 24px;
}
.amountNumber i {
  font-style: normal;
  margin-left: 16px;
}
.moneyTime {
  margin-left: 24px;
  color: #a8ebe8;
}
.Gotop1 {
  position: fixed;
  right: 60px;
  bottom: 180px;
  z-index: 20;
}
.subscribe {
  width: 40px;
  height: 42px;
  background: #71717b url(../../assets/xuanfu.png) no-repeat -9px -10px;
  position: absolute;
  top: -46px;
  display: block;
}
.scan {
  width: 40px;
  height: 42px;
  background: #71717b url(../../assets/xuanfu.png) no-repeat -9px -52px;
  position: absolute;
  top: 0;
  display: block;
}
.server {
  width: 40px;
  height: 42px;
  background: #71717b url(../../assets/xuanfu.png) no-repeat -9px -92px;
  margin: 4px 0;
  position: absolute;
  top: 42px;
  display: block;
}
.top {
  width: 40px;
  height: 42px;
  background: #71717b url(../../assets/xuanfu.png) no-repeat -9px -136px;
  position: absolute;
  top: 92px;
  display: block;
}
.subscribe1 {
  width: 40px;
  line-height: 42px;
  background: #11cc99;
  color: #fff;
  text-align: center;
  position: absolute;
  top: -46px;
  display: none;
}
.scan1 {
  width: 40px;
  line-height: 42px;
  background: #11cc99;
  color: #fff;
  text-align: center;
  position: absolute;
  top: 0;
  display: none;
}
.server1 {
  width: 40px;
  line-height: 42px;
  margin: 4px 0;
  background: #11cc99;
  color: #fff;
  text-align: center;
  position: absolute;
  top: 42px;
  display: none;
}
.top1 {
  width: 40px;
  line-height: 42px;
  background: #11cc99;
  color: #fff;
  text-align: center;
  position: absolute;
  top: 92px;
  display: none;
}
.erQR {
  width: 146px;
  height: 170px;
  background: url(../../assets/WechatIMG1.png) no-repeat -95px -20px;
  position: absolute;
  right: 10px;
  display: none;
}
.kefuphone {
  font-size: 20px;
  color: #fff;
  text-align: center;
  margin: 10px 0 0 0;
}
.zhuanxian {
  font-size: 12px;
  color: #fff;
  margin-left: 22px;
}
/*--------------------------------预约----------------------------------*/
.gxpfloat {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 100;
}
.appointment {
  width: 340px;
  min-height: 300px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -170px;
  margin-top: -190px;
  font-size: 14px;
}
.appointment ul li input {
  text-indent: 8px;
}
.gxpClose {
  float: right;
  width: 20px;
  line-height: 20px;
  text-align: center;
  margin: 6px 6px 0 0;
  font-size: 20px;
  color: #909090;
}
.gxpClose:hover {
  background: #01b784;
}
.Consultation {
  margin: 20px 0 10px 120px;
  font-size: 16px;
}
.gxpInput {
  border: 1px solid #e6e6e6;
  margin-left: 20px;
  width: 180px;
  height: 30px;
}
.gxpInput1 {
  border: 1px solid #e6e6e6;
  margin-left: 20px;
  width: 92px;
  height: 30px;
}
.gxpInput2 {
  background: #eeeeee;
}
.gxpIn {
  margin: 10px 50px;
}
.gxpCode {
  margin-left: 34px;
}
.CustomerService {
  width: 280px;
  margin: 10px 0 20px 35px;
  font-size: 12px;
  color: #909090;
}
.sendCode {
  width: 90px;
  line-height: 30px;
  background: #01b784;
  float: right;
  margin-right: 56px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  border: 0;
  outline: 0;
}
.sendCode1 {
  width: 90px;
  line-height: 30px;
  background: #e6e6e6;
  float: right;
  margin-right: 56px;
  text-align: center;
  font-size: 14px;
  color: #000;
  border: 0;
  outline: 0;
}
.sendCode:hover {
  cursor: pointer;
}
.ensure {
  width: 200px;
  line-height: 30px;
  background: #01b784;
  text-align: center;
  color: #fff;
  margin: 20px 0 30px 80px;
  border-radius: 5px;
}
.courseDetails .errormessage {
  margin-left: 100px;
  color: red;
}
.ssor {
  margin-bottom: 10px;
}
.sser {
  margin-top: 10px;
}
.activebg {
  background: #eeeeee;
}
.dibian {
  background: #000;
}
.videoplay {
  width: 500px;
  line-height: 247px;
  text-align: center;
  color: #eee;
}
.Gotop1 {
  cursor: pointer;
}

.qrcodeAlert {
  width: 540px;
  height: 100%;
  background: url("../../assets/detail-qrcode-bg.png") left bottom / cover
    no-repeat;
  position: absolute;
  left: 0;
  bottom: 0;
}
.qrcodeImg {
  width: 100px;
  position: absolute;
  left: 143px;
  bottom: 68px;
}

.coures-container .right-buttons {
  width: 60px;
  position: fixed;
  right: 0;
  bottom: 100px;
  color: #fff;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  overflow: hidden;
  z-index: 20;
}

.coures-container .right-button {
  width: 100%;
  height: 80px;
  background-color: #1f946c;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  font-size: 12px;
  cursor: pointer;
}

.coures-container .right-button.active {
  background-color: #fff;
  color: #1f946c;
}

.coures-container .right-button.active .iconfont {
  color: #1f946c;
}

.coures-container .right-buttons .iconfont {
  font-size: 40px;
  color: #fff;
  overflow: hidden;
  line-height: 40px;
}

.coures-container .right-buttons .ivu-icon {
  font-size: 40px;
  color: #fff;
  overflow: hidden;
  line-height: 40px;
  display: block;
}

/* 弹窗相关 */

.coures-container .sub-online-container {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
}

.coures-container .sub-online {
  width: 468px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  overflow: hidden;
}

.coures-container .sub-online .title {
  width: 100%;
  height: 68px;
  left: 68px;
  background-color: #187759;
  color: #fff;
  font-size: 24px;
  text-align: center;
  line-height: 68px;
}

.coures-container .sub-online .ivu-form {
  padding: 24px 31px 19px 24px;
  background-color: #fff;
  width: 100%;
}

.coures-container .sub-online .ivu-input,
.coures-container
  .sub-online
  .ivu-select-large.ivu-select-single
  .ivu-select-selection {
  height: 50px;
  font-size: 16px;
}

.coures-container
  .sub-online
  .ivu-select-large.ivu-select-single
  .ivu-select-selection
  .ivu-select-placeholder,
.coures-container
  .sub-online
  .ivu-select-large.ivu-select-single
  .ivu-select-selection
  .ivu-select-selected-value {
  height: 50px;
  line-height: 50px;
}

.coures-container .ivu-select-dropdown {
  position: absolute !important;
  left: 0px !important;
}

.coures-container .sub-online .ivu-form .ivu-form-item {
  margin-bottom: 14px;
}

.coures-container .sub-online .code .ivu-btn {
  background-color: #187759;
  width: 100%;
  border-radius: 4px;
  height: 100%;
  color: #fff;
  font-size: 16px;
}

.coures-container .sub-online .code .ivu-btn.disable {
  background-color: #f3f3f3;
  color: #ccc;
}

.coures-container .sub-online .submit.ivu-form-item {
  margin-bottom: 0;
  margin-top: 27px;
}

.coures-container .submit .ivu-btn {
  width: 100%;
  border-radius: 4px;
  color: #fff;
  background-color: #187759;
  height: 50px;
  font-size: 24px;
  line-height: 50px;
  padding: 0;
}

/* 弹窗相关结束 */
.coures-container .serverPhone {
  width: 166px;
  height: 60px;
  background-color: #187759;
  position: fixed;
  right: 85px;
  bottom: 100px;
  border-radius: 4px;
  /* display: none; */
}

.coures-container .serverPhone::after {
  content: "";
  display: block;
  position: absolute;
  right: -7px;
  top: 10px;
  border-style: solid;
  border-width: 5px 0 5px 7px;
  border-color: transparent transparent transparent #187759;
}
.coures-container .kefuphone {
  font-size: 20px;
  color: #fff;
  text-align: center;
  margin: 10px 0 0 0;
}

.coures-container .zhuanxian {
  font-size: 12px;
  color: #fff;
  margin-left: 22px;
}

.coures-container .iframe-container {
  position: fixed;
  z-index: 19;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.coures-container .iframe-container #consult-ol {
  position: absolute;
  right: 80px;
  bottom: 100px;
  width: 20vw;
  height: 30vw;
  border: 1px solid #dfdfdf;
}
.coures-container .errormessage {
  color: red;
}
.coures-container .demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.coures-container .demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.coures-container .ivu-spin-fix {
  background-color: rgba(0, 0, 0, .5);
}
.coures-container .ivu-spin {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// CourseDetails.vue?3d9ada0e